module.exports = __webpack_public_path__ + "static/logos_footer_line-c72b03cb023d5c642a31662b6f6f110a.png";